import * as React from 'react';

export const TextIcon = () => {
    return (
        <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
        >
            <path d="M22.16,8.59a.29.29,0,0,1,.33.33v1.79a.29.29,0,0,1-.33.33H17.38V25a.29.29,0,0,1-.32.32H14.92a.29.29,0,0,1-.33-.32V11H9.84a.29.29,0,0,1-.33-.33V8.92a.29.29,0,0,1,.33-.33Z" />
        </svg>
    );
};



// WEBPACK FOOTER //
// ./src/App/shared/icons/pt-icon-text.tsx